import classNames from 'classnames';
import { when } from 'mobx';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { Button } from '@udemy/react-core-components';
import { serverOrClient } from '@udemy/shared-utils';
import { ShoppingClient } from '@udemy/shopping';
import { useUDData } from '@udemy/ud-data';
import { getConfig } from '../config';
import { CartCheckoutClickEvent, COMPONENT_VERSION } from '../events';
import { CheckoutReferrerHelper } from '../express-checkout-button/checkout-referrer-helper';
import styles from "./checkout-button.module.css";
import { attachCheckoutButtonParams } from './helpers';
export const CheckoutButton = observer(({
  buttonProps,
  className,
  hideTerms,
  iconProps,
  isDisabled = false
}) => {
  const {
    gettext,
    interpolate,
    ngettext
  } = useI18n();
  const {
    me: udMe
  } = useUDData();
  const config = getConfig(gettext, interpolate, ngettext);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    (async () => {
      await when(() => !udMe.isLoading);
      setIsLoading(false);
    })();
  }, [udMe.isLoading]);
  const handleCheckoutClick = () => {
    Tracker.publishEvent(new CartCheckoutClickEvent(COMPONENT_VERSION.UDLITE));
    ShoppingClient.freezeCheckoutList('cart');
    CheckoutReferrerHelper.saveCheckoutReferrer();
    serverOrClient.global.location.href = attachCheckoutButtonParams(config.urls.checkoutPage);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['checkout-button-container'], className)
  }, /*#__PURE__*/React.createElement(Button, Object.assign({
    disabled: isLoading || isDisabled,
    onClick: handleCheckoutClick,
    round: false,
    udStyle: "secondary"
  }, buttonProps, {
    className: classNames(styles['checkout-button'], buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className)
  }), /*#__PURE__*/React.createElement("span", null, gettext('Proceed to checkout')), /*#__PURE__*/React.createElement(Icon, Object.assign({
    glyph: "arrow-right",
    size: "medium",
    label: false
  }, iconProps))), !hideTerms && /*#__PURE__*/React.createElement("div", {
    className: styles['checkout-button-terms']
  }, gettext("You won't be charged yet")));
});
//# sourceMappingURL=checkout-button.react-component.js.map